export default function (jsonData, chang = false) {
  return chang ? window.JSON.parse(jsonData) : jsonData
}



// WEBPACK FOOTER //
// ./src/js/json_data.js